/* @flow */

import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';
import type { Fakt, NumberFormat as NumberFormatType } from './types';
import Diagram from './Diagram';

export type Props = {
  data?: Fakt[],
  activeState?: Fakt,
  hoverState?: Fakt,
  onStateChange: (state?: Fakt, stayFocussed?: boolean) => void,
  unitFormat: NumberFormatType;
  average?: number;
  orderascending?: boolean,
}

const DiagramContainer = ({
  data, activeState, hoverState, onStateChange, unitFormat, average, orderascending,
}: Props): React$Element<"div"> => {
  const [bwValue, setBwValue] = useState();
  const [activeValue, setActiveValue] = useState();
  const [activeStateName, setActiveStateName] = useState('Bundesland');
  const numberProps = {
    thousandSeparator: unitFormat.thousandssep,
    decimalSeparator: unitFormat.decpoint || ',',
    decimalScale: unitFormat.decimals,
    suffix: unitFormat.unit && ` ${unitFormat.unit}`,
    displayType: 'text',
    fixedDecimalScale: true,
  };

  useEffect(() => {
    if (data) {
      const bw = data.find(i => i.faktregion.zncode === 'BW');

      if (bw) {
        setBwValue(bw.amount);
      }
    }
  }, [data]);

  useEffect(() => {
    if ((hoverState || activeState)
      && ((hoverState && hoverState.faktregion.zncode !== 'BW')
      || (activeState && activeState.faktregion.zncode !== 'BW'))) {
      setActiveValue(hoverState ?
        hoverState.amount : activeState && activeState.amount);

      setActiveStateName(hoverState ?
        hoverState.faktregion.title : activeState && activeState.faktregion.title);
    } else {
      setActiveStateName('Bundesland');
      setActiveValue(undefined);
    }
  }, [activeState, hoverState]);

  const renderValue = (value?: string | number | null, isBW?: boolean) => {
    if (value === null) {
      return 'Keine Angabe.';
    }

    if (value === undefined && !isBW) {
      return 'Bitte wählen Sie ein Bundesland, das Sie mit Baden-Württemberg vergleichen möchten.';
    }

    return (
      <NumberFormat
        value={value}
        {...numberProps}
      />
    );
  };

  return (
    <div className='map-is__diagram-container'>
      <div className='map-is__compare'>
        <dl className='map-is__compare-item'>
          <dt className='headline__kicker'>Baden-Württemberg</dt>
          {data &&
            <dd className={classNames(
              'map-is__compare-value',
              bwValue === null && 'map-is__compare-value--inactive',
            )}>
              {renderValue(bwValue, true)}
            </dd>
          }
        </dl>
        <dl className='map-is__compare-item'>
          <dt className='headline__kicker'>{activeStateName}</dt>
          <dd className={classNames(
            'map-is__compare-value',
            (activeValue === undefined || activeValue === null) && 'map-is__compare-value--inactive',
          )}>
            {renderValue(activeValue)}
          </dd>
        </dl>
      </div>
      <Diagram
        activeState={activeState}
        hoverState={hoverState}
        data={data}
        onStateChange={onStateChange}
        numberProps={numberProps}
        average={average}
        orderascending={orderascending}
      />
    </div>
  );
};

export default DiagramContainer;
